import { useState, useContext, useEffect, useRef } from "react";
import ApiContext from "src/provider/API/call-service";
import utility from "src/utils/utility";
import {
  AppText,
  CustomContainer,
  FlexColumn,
  FlexRow,
  ScreenContainer,
} from "src/style";
import { ReportFilter, ServerSideTable } from "src/component";
import helpers from "src/utils/helpers";
import {
  failedTxReportData,
  failedTxReportColumn,
  surveyReportColumn,
} from "src/utils/tableLayout";
import { ISurveyTriggers } from "src/model";
import { TotalResponses } from "src/assets/svg/total-survey-responses";
import { AverageSurvey } from "src/assets/svg/average-survey";
import { ThumbsUp } from "src/assets/svg/thumbs-up";
import { ThumbsDown } from "src/assets/svg/thumbs-down";
import { useTranslation } from "react-i18next";

const SurveyReport = () => {
  const { t } = useTranslation();
  const { API, downloadReport } = useContext(ApiContext);
  const [reportData, setReportData] = useState<any>(null);
  const [report, setReport] = useState<any>(null);
  const [showFilter, setShowFilter] = useState<boolean>(false);
  const [resetPagination, setResetPagination] = useState<boolean>(false);
  const [selectedInstitution, setSelectedInstitution] = useState<string>("");
  const [surveyTriggers, setSurveyTriggers] = useState<ISurveyTriggers[]>([]);
  const [surveySummary, setSurveySummary] = useState<any>(null);


  const listSurveyTriggers = () => {
    return surveyTriggers?.map((item) => ({
      label: item.triggerName,
      value: item.id,
    }));
  };

  const summaryData = [
    {
      icon: <TotalResponses />,
      label: t("surveyReport.totalResponses"),
      value: surveySummary?.totalResponses || 0,
    },
    {
      icon: <AverageSurvey />,
      label: t("surveyReport.averageRating"),
      value: surveySummary?.averageRating || 0,
      totalValue: surveySummary?.totalRatingResponses || 0,
    },
    {
      icon: <ThumbsUp />,
      label: t("surveyReport.positiveResponses"),
      value: surveySummary?.totalPositiveResponses || 0,
    },
    {
      icon: <ThumbsDown />,
      label: t("surveyReport.negativeResponses"),
      value: surveySummary?.totalNegativeResponses || 0,
    },
  ];

  const cleanedData = report?.map((item: any) => {
    return {
      ...item,
      responses: JSON.parse(item.responses),
    };
  });

  const filterDataRef = useRef({});

  async function handleFetchReport(
    pageNumber = 1,
    pageSize = 10,
    isDownload = false
  ) {
    if (selectedInstitution) {
      const response = await API.surveyResponse(pageNumber, pageSize, {
        ...filterDataRef.current,
        institutionCode: selectedInstitution,
        returnMax: isDownload,
      });

      if (response) {
        if (isDownload) {
          return downloadReport(response, "SURVEY_REPORT");
        }
        setReportData(response);
        setReport(
          helpers.addSerialNumberToItems(response?.data, {
            pageNumber,
            pageSize,
          })
        );
      }
    }
  }

    async function fetchSurveySummary() {
    if (selectedInstitution) {
      const response = await API.getInstitutionSurveySummary(
        selectedInstitution,{ ...filterDataRef.current }
      );

      if (response) {
        setSurveySummary(response);
      }
    }
  }

  async function fecthTriggers() {
    
    if (selectedInstitution) {
      const response = await API.getSurveyTriggers(selectedInstitution);
      if (response) setSurveyTriggers(response);
    }
  }

  function handleClear() {
    filterDataRef.current = {};
    handleFetchReport();
    fetchSurveySummary();
    setResetPagination(!resetPagination);
  }


  useEffect(() => {
    filterDataRef.current = {};
    handleFetchReport();
    fecthTriggers();
    fetchSurveySummary();
  }, [selectedInstitution]);

  return (
    <>
      <ScreenContainer>
        <CustomContainer topMargin="3" className="no-submenu-container">
          <ServerSideTable
            tableData={cleanedData || []}
            tableColumns={surveyReportColumn(t,surveyTriggers)}
            dataFetchMethod={handleFetchReport}
            totalRows={reportData?.total}
            tableTitle={t("surveyReport.surveyReport")}
            customStyle
            shouldResetPagination={resetPagination}
            selectInstitution
            canFilter={() => setShowFilter(true)}
            canClear={handleClear}
            downloadAction={() => handleFetchReport(1, 10, true)}
            onInstitutionSelect={(value: any) => {
              setSelectedInstitution(value?.value);
              handleFetchReport(1, 10);
            }}
            showSurvey
            summaryData={summaryData}
          />
        </CustomContainer>
      </ScreenContainer>
      {showFilter && (
        <ReportFilter
          type="survey"
          top="25"
          onApplyFilter={() => {
            fetchSurveySummary();
            handleFetchReport();
          }}
          setFilterData={(data: any) => {
            filterDataRef.current = data;
          }}
          close={() => setShowFilter(false)}
          surveyTriggerList={listSurveyTriggers()}
        />
      )}
    </>
  );
};

export default utility.routeData("survey-report", "SurveyReport", <SurveyReport />);
